<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Transfer
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-card-actions class="justify-center">
            <v-btn @click="addTerm" outline large class="white--text">
              <v-icon left dark> add </v-icon>
              NEW TRANSFER
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="transferHeader"
          :items="transferListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ getFirmName(props.item.firm) }}</b>
            </td>
            <td>
              <b>{{ new Date(props.item.date).toLocaleDateString("en-GB") }}</b>
            </td>
            <td>
              <b v-if="props.item.transferCategory == 'B2B'"
                >Bank Account -To- Bank Account</b
              >
              <b v-else-if="props.item.transferCategory == 'B2C'"
                >Bank Account -To- Cash Account</b
              >
              <b v-else-if="props.item.transferCategory == 'C2B'"
                >Cash Account -To- Bank Account</b
              >
            </td>
            <td>
              <b>{{ props.item["amount"] }}</b>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="editTransfer(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteTerm(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="transferDialog" max-width="1000px">
      <v-card v-if="currentTransfer">
        <v-card-title class="primary white--text">
          <span class="headline">Transfer</span>
          <v-spacer />
          <v-btn icon dark @click.native="transferDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- <v-container grid-list-md>
            <v-layout wrap>
           -->
          <v-radio-group
            v-model="currentTransfer.transferCategory"
            :mandatory="false"
            :disabled="currentTransfer['.key']"
          >
            <v-radio
              class="font-weight-bold"
              label="From Bank Account -To- Bank Account"
              value="B2B"
            ></v-radio>

            <v-radio
              label="From Bank Account -To- Cash Account"
              value="B2C"
            ></v-radio>

            <v-radio
              label="From Cash Account -To- Bank Account"
              value="C2B"
            ></v-radio>
          </v-radio-group>
          <v-menu
            :close-on-content-click="false"
            v-model="transferdatepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="currentTransfer.date"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="currentTransfer.date"
              @input="transferdatepicker = false"
            />
          </v-menu>

          <v-select
            v-model="currentTransfer.firm"
            :items="firmsByBrand"
            label="Select Firm"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.text }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.firm.name}${
                      data.item.firm.proprietor
                        ? ' | ' + data.item.firm.proprietor
                        : ''
                    } | ₹: ${(data.item.firm.amount || 0).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-select>

          <v-autocomplete
            :items="banksByFirms"
            v-model="currentTransfer.bankFrom"
            @change="checkForSameAccount"
            flat
            hide-no-data
            hide-details
            v-if="
              currentTransfer.firm &&
              (currentTransfer.transferCategory == 'B2C' ||
                currentTransfer.transferCategory == 'B2B')
            "
            label="From Account"
            clearable
          >
            <template slot="selection" slot-scope="data">
              {{
                `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? " | " + data.item.account.bankName
                                : ""
                            }
                            ${
                              data.item.account.accountType
                                ? " | " + data.item.account.accountType
                                : ""
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
              }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? ' | ' + data.item.account.bankName
                                : ''
                            }
                            ${
                              data.item.account.accountType
                                ? ' | ' + data.item.account.accountType
                                : ''
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-autocomplete>

          <v-autocomplete
            :items="banksByFirms"
            v-model="currentTransfer.bankTo"
            @change="checkForSameAccount"
            v-if="
              currentTransfer.firm &&
              (currentTransfer.transferCategory == 'C2B' ||
                currentTransfer.transferCategory == 'B2B')
            "
            flat
            hide-no-data
            hide-details
            label="To Account"
            clearable
          >
            <template slot="selection" slot-scope="data">
              {{
                `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? " | " + data.item.account.bankName
                                : ""
                            }
                            ${
                              data.item.account.accountType
                                ? " | " + data.item.account.accountType
                                : ""
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
              }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title
                  v-html="
                    `${data.item.text}
                            ${
                              data.item.account.bankName
                                ? ' | ' + data.item.account.bankName
                                : ''
                            }
                            ${
                              data.item.account.accountType
                                ? ' | ' + data.item.account.accountType
                                : ''
                            }
                            | ₹: ${(
                              data.item.account.amount || 0
                            ).toLocaleString()}`
                  "
                />
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-text-field
            v-if="currentTransfer.firm"
            label="Amount"
            v-model="currentTransfer.amount"
          >
          </v-text-field>
          <v-select
            v-if="
              currentTransfer.amount &&
              currentTransfer.transferCategory == 'C2B'
            "
            v-model="currentTransfer.depositVia"
            :items="[
              {
                text: 'Atm Deposit',
                value: 'Atm Deposit',
              },
              {
                text: 'Cash Counter',
                value: 'Cash Counter',
              },
            ]"
            label="Deposit Via"
            required
          ></v-select>
          <v-select
            v-if="
              currentTransfer.amount &&
              currentTransfer.transferCategory == 'B2C'
            "
            v-model="currentTransfer.depositVia"
            :items="[
              {
                text: 'Atm Withdrawn',
                value: 'Atm',
              },
              {
                text: 'Cash Counter',
                value: 'Cash Counter',
              },
            ]"
            label="withdrawn Via"
            required
          ></v-select>
          <v-select
            dense
            v-if="
              currentTransfer.amount &&
              currentTransfer.transferCategory == 'B2B'
            "
            :items="[
              {
                text: 'Cheque',
                value: 'Cheque',
              },
              {
                text: 'NEFT',
                value: 'NEFT',
              },
              {
                text: 'RTGS',
                value: 'RTGS',
              },
              {
                text: 'IMPS',
                value: 'IMPS',
              },
            ]"
            label="Select Transfer type"
            v-model="currentTransfer.bankTransferType"
          ></v-select>
          <v-text-field
            label="Remark"
            v-model="currentTransfer.remark"
          ></v-text-field>

          <!-- </v-layout>
          </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            v-if="!currentTransfer['.key']"
            @click="saveTerms"
          >
            <v-icon right dark>swap_horiz</v-icon>Save
          </v-btn>
          <v-btn color="primary" v-else @click="updateTransfer">
            <v-icon right dark>swap_horiz</v-icon>Update
          </v-btn>
          <v-btn color="primary" @click="transferDialog = false">
            <v-icon left dark>cancel</v-icon>Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" top color="error" :timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
    <v-snackbar v-model="snackbarSuccess" top color="success" :timeout="3000">
      {{ snackbarSuccessText }}
    </v-snackbar>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      transferDialog: false,
      currentTransfer: {},
      transferdatepicker: null,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      termsList: [],
      transferHeader: [
        // { text: "Print- ID", value: "Term - ID" },
        { text: "Firm", value: "Name" },
        { text: "Date", value: "Name" },
        { text: "Transfer Category", value: "Description" },
        { text: "Amount", value: "Description" },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
      ],
    };
  },
  created() {
    this.$bindAsArray(
      "invoices",
      this.$root.$firebaseRefs.invoice
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "banks",
      this.$root.$firebaseRefs.account
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "transactions",
      this.$root.$firebaseRefs.transaction
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","brandFinYear"]),
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          return {
            firm: item,
            text: item["name"],
            value: item[".key"],
          };
        });
    },
    banksByFirms() {
      return this.banks
        .filter(
          (item) =>
            item["brand"] === this.selectedBrand &&
            item["firm"] == this.currentTransfer.firm
        )
        .map((item) => {
          return {
            account: item,
            text: item["accountnumber"],
            value: item[".key"],
          };
        });
    },
    transferListByBrand() {
      return this.transactions.filter(
        (item) => item["brand"] === this.selectedBrand
      );
    },
  },
  methods: {
    saveTerms() {
      console.log(this.currentTransfer);
      this.transferAmount(false, false);

      this.transferDialog = false;
    },
    checkForSameAccount() {
      if (
        this.currentTransfer.bankFrom != null &&
        this.currentTransfer.bankTo != null
      ) {
        if (this.currentTransfer.bankFrom == this.currentTransfer.bankTo) {
          this.snackbar = true;
          this.snackbarText = "Both Accounts cannot be same";
          return false;
        } else {
          return true;
        }
      }
    },

    transferAmount(reverse, isDelete) {
      switch (this.currentTransfer.transferCategory) {
        case "B2B": {
          this.bankToBank(reverse, isDelete);
          break;
        }
        case "C2B": {
          reverse
            ? this.bankToCash(reverse, isDelete)
            : this.cashToBank(reverse);
          break;
        }
        case "B2C": {
          reverse
            ? this.cashToBank(reverse, isDelete)
            : this.bankToCash(reverse);
          break;
        }
      }
    },
    addTerm() {
      this.currentTransfer = {
        firm: null,
        bankFrom: null,
        bankTo: null,
        amount: 0,
        paymentType: "cash",
        date: new Date().toISOString().substr(0, 10),
        transferCategory: "B2B",
        brand: this.selectedBrand,
        remark: "",
      };
      this.transferDialog = true;
    },
    addInvoice() {
      if (this.currentTransfer[".key"]) {
        this.$root.$firebaseRefs.invoice
          .child(this.currentTransfer["creditInvoiceId"])
          .remove();
        this.$root.$firebaseRefs.invoice
          .child(this.currentTransfer["debitInvoiceId"])
          .remove();
      }
      let invoiceDataCredit = {
        brand: this.selectedBrand,
        brandFinYear : this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: true,
        totalAmount: Number.parseFloat(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory,
      };
      let invoiceDataDebit = {
        brand: this.selectedBrand,
        brandFinYear : this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: false,
        totalAmount: Number.parseFloat(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory,
      };

      if (this.currentTransfer.transferCategory == "B2B") {
        invoiceDataCredit[
          "transferType"
        ] = this.currentTransfer.bankTransferType;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;
        invoiceDataDebit[
          "transferType"
        ] = this.currentTransfer.bankTransferType;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "B2C") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "C2B") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      }
      let res1 = this.$root.$firebaseRefs.invoice.push(invoiceDataCredit);
      let res2 = this.$root.$firebaseRefs.invoice.push(invoiceDataDebit);
      this.currentTransfer["creditInvoiceId"] = res1["key"];
      this.currentTransfer["debitInvoiceId"] = res2["key"];
      this.currentTransfer["date"] = new Date(
        this.currentTransfer.date
      ).getTime();
      if (this.currentTransfer[".key"]) {
        let key = this.currentTransfer[".key"];
        delete this.currentTransfer[".key"];
        this.$root.$firebaseRefs.transaction
          .child(key)
          .set(this.currentTransfer);
      } else {
        this.$root.$firebaseRefs.transaction.push(this.currentTransfer);
      }
    },
    bankToBank(reverse, isDelete) {
      var self = this;
      let result = this.checkForSameAccount();
      let bankFrom = reverse
        ? this.currentTransfer.bankTo
        : this.currentTransfer.bankFrom;
      let bankTo = reverse
        ? this.currentTransfer.bankFrom
        : this.currentTransfer.bankTo;
      if (result) {
        if (this.currentTransfer.amount == null) {
          this.snackbar = true;
          this.snackbarText = "Amount cannot be empty";
        } else {
          this.$root.$firebaseRefs.account
            .child(bankFrom)
            .once("value")
            .then(function (snap) {
              if (
                Number(snap.val().amount) >= Number(self.currentTransfer.amount)
              ) {
                self.$root.$firebaseRefs.account.child(bankFrom).update({
                  amount:
                    Number(snap.val().amount) -
                    Number(self.currentTransfer.amount),
                });
                self.$root.$firebaseRefs.account
                  .child(bankTo)
                  .once("value")
                  .then(function (snap) {
                    self.$root.$firebaseRefs.account.child(bankTo).update({
                      amount:
                        Number(snap.val().amount) +
                        Number(self.currentTransfer.amount),
                    });
                  });
                setTimeout(function () {
                  if (!reverse) {
                    self.addInvoice();
                  }
                  if (isDelete) {
                    self.$root.$firebaseRefs.invoice
                      .child(self.currentTransfer["creditInvoiceId"])
                      .remove();
                    self.$root.$firebaseRefs.invoice
                      .child(self.currentTransfer["debitInvoiceId"])
                      .remove();
                    self.$root.$firebaseRefs.transaction
                      .child(self.currentTransfer[".key"])
                      .remove();
                  }
                  if (reverse && !isDelete) {
                    this.transferAmount(false, false);
                  }
                }, 1000);
              } else {
                self.snackbar = true;
                self.snackbarText = "Insufficient Balance";
              }
            });
        }
      } else {
        this.snackbar = true;
        this.snackbarText = "Both Accounts cannot be same";
      }
    },

    bankToCash(reverse, isDelete) {
      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        let bankFrom = reverse
          ? this.currentTransfer.bankTo
          : this.currentTransfer.bankFrom;
        this.$root.$firebaseRefs.account
          .child(bankFrom)
          .once("value")
          .then(function (snap) {
            if (
              Number(snap.val().amount) >= Number(self.currentTransfer.amount)
            ) {
              self.$root.$firebaseRefs.account.child(bankFrom).update({
                amount:
                  Number(snap.val().amount) -
                  Number(self.currentTransfer.amount),
              });
              self.$root.$firebaseRefs.firm
                .child(self.currentTransfer.firm)
                .once("value")
                .then(function (snap) {
                  self.$root.$firebaseRefs.firm
                    .child(self.currentTransfer.firm)
                    .update({
                      amount:
                        Number(snap.val().amount) +
                        Number(self.currentTransfer.amount),
                    });
                });
              setTimeout(function () {
                if (!reverse) {
                  self.addInvoice();
                }
                if (isDelete) {
                  self.$root.$firebaseRefs.invoice
                    .child(self.currentTransfer["creditInvoiceId"])
                    .remove();
                  self.$root.$firebaseRefs.invoice
                    .child(self.currentTransfer["debitInvoiceId"])
                    .remove();
                  self.$root.$firebaseRefs.transaction
                    .child(self.currentTransfer[".key"])
                    .remove();
                }
                if (reverse && !isDelete) {
                  this.transferAmount(false, false);
                }
              }, 1000);
            } else {
              self.snackbar = true;
              self.snackbarText = "Insufficient Balance";
            }
          });
      }
    },
    cashToBank(reverse, isDelete) {
      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        let bankTo = reverse
          ? this.currentTransfer.bankFrom
          : this.currentTransfer.bankTo;
        this.$root.$firebaseRefs.firm
          .child(this.currentTransfer.firm)
          .once("value")
          .then(function (snap) {
            if (
              Number(snap.val().amount) >= Number(self.currentTransfer.amount)
            ) {
              self.$root.$firebaseRefs.firm
                .child(self.currentTransfer.firm)
                .update({
                  amount:
                    Number(snap.val().amount) -
                    Number(self.currentTransfer.amount),
                });

              self.$root.$firebaseRefs.account
                .child(bankTo)
                .once("value")
                .then(function (snap) {
                  self.$root.$firebaseRefs.account.child(bankTo).update({
                    amount:
                      Number(snap.val().amount) +
                      Number(self.currentTransfer.amount),
                  });
                });
              setTimeout(function () {
                if (!reverse) {
                  self.addInvoice();
                }
                if (isDelete) {
                  self.$root.$firebaseRefs.invoice
                    .child(self.currentTransfer["creditInvoiceId"])
                    .remove();
                  self.$root.$firebaseRefs.invoice
                    .child(self.currentTransfer["debitInvoiceId"])
                    .remove();
                  self.$root.$firebaseRefs.transaction
                    .child(self.currentTransfer[".key"])
                    .remove();
                }
                if (reverse && !isDelete) {
                  this.transferAmount(false, false);
                }
              }, 1000);
            } else {
              self.snackbar = true;
              self.snackbarText = "Insufficient Balance";
            }
          });
      }
    },
    getFirmName(e) {
      let firm;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter((item) => item[".key"] === e)[0];
      }
      if (firm) return firm.name;
    },
    getBankName(e) {
      let bank = this.banks.filter((item) => item[".key"] === e)[0];
      if (bank) return bank.bankName + " | " + bank["accountnumber"];
    },
    updateTransfer() {
      this.transferAmount(true, false);
      this.transferDialog = false;
    },
    editTransfer(term) {
      this.currentTransfer = JSON.parse(JSON.stringify(term));
      (this.currentTransfer["date"] = new Date(this.currentTransfer["date"])
        .toISOString()
        .substr(0, 10)),
        (this.transferDialog = true);
    },
    deleteTerm(term) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentTransfer = JSON.parse(JSON.stringify(term));
        this.transferAmount(true, true);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/Transactions/Transfer.vue